<template>
  <edit-employee-layout :employee-id="empNumber" screen="qualifications">
    <div class="orangehrm-horizontal-padding orangehrm-top-padding">
      <oxd-text tag="h6" class="orangehrm-main-title">{{
        $t('general.qualifications')
      }}</oxd-text>
      <oxd-divider />
    </div>
    <employee-work-experience
      v-if="!isEmployee"
      :employee-id="empNumber"
    ></employee-work-experience>
    <training-list v-if="!isEmployee" :employee-id="empNumber" />
    <employee-education :employee-id="empNumber"></employee-education>
    <employee-skills
      :employee-id="empNumber"
      :levels="levels"
    ></employee-skills>
    <employee-languages
      :employee-id="empNumber"
      :fluencies="fluencies"
      :competencies="competencies"
    ></employee-languages>
    <employee-license
      v-if="!isEmployee"
      :employee-id="empNumber"
    ></employee-license>
  </edit-employee-layout>
</template>

<script>
import EditEmployeeLayout from '@/orangehrmPimPlugin/components/EditEmployeeLayout';
import EmployeeSkills from '@/orangehrmPimPlugin/components/EmployeeSkills';
import EmployeeEducation from '@/orangehrmPimPlugin/components/EmployeeEducation';
import EmployeeLanguages from '@/orangehrmPimPlugin/components/EmployeeLanguages';
import EmployeeWorkExperience from '@/orangehrmPimPlugin/components/EmployeeWorkExperience';
import EmployeeLicense from '@/orangehrmPimPlugin/components/EmployeeLicense';
import TrainingList from '@/orangehrmPimPlugin/components/training/TrainingList';
import UserRoles from '@/orangehrmTrainigPlugin/constants/UserRoles';

const userAuth = window.appGlobal.user;

export default {
  components: {
    'edit-employee-layout': EditEmployeeLayout,
    'employee-skills': EmployeeSkills,
    'employee-education': EmployeeEducation,
    'employee-languages': EmployeeLanguages,
    'employee-work-experience': EmployeeWorkExperience,
    'employee-license': EmployeeLicense,
    'training-list': TrainingList,
  },
  props: {
    empNumber: {
      type: String,
      required: true,
    },
    fluencies: {
      type: Array,
      required: true,
    },
    competencies: {
      type: Array,
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isViewer() {
      return userAuth.id != parseInt(this.empNumber) &&
        userAuth.roleId != UserRoles.ADMIN.id
        ? true
        : false;
    },
    isEmployee() {
      if (this.isSubordinate) return false;

      return [UserRoles.ESS.id, UserRoles.SUPERVISOR.id].includes(
        userAuth.roleId,
      ) && this.isViewer
        ? true
        : false;
    },
    isSubordinate() {
      if (userAuth.roleId === UserRoles.ADMIN.id) return false;

      return (
        userAuth.subordinates.includes(parseInt(this.empNumber)) &&
        userAuth.roleId === UserRoles.SUPERVISOR.id
      );
    },
  },
};
</script>
